const mandatory = () => {
    throw new Error('Missing parameter');
};

export {
    mandatory
};
